import React, { useContext } from 'react';
import { useOutlet } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { UserContext } from '../contexts/UserContext';
import { UsersList } from '../components/users/UsersList';

export type LayoutUsersProps = {
  /** When false, omit the large page title (e.g. under Admin sub-tabs). Default true. */
  showPageTitle?: boolean;
};

/**
 * Renders nested routes via `<Outlet />` when this layout is active under `/users`.
 * When embedded from the home shell (no child route match), `useOutlet()` is null
 * and we show `UsersList` directly so the table still appears.
 */
export const LayoutUsers: React.FC<LayoutUsersProps> = ({ showPageTitle = true }) => {
  const { user } = useContext(UserContext);
  const outlet = useOutlet();
  const canRead = Boolean(user?.permissions?.users?.read);
  const canCreate = Boolean(user?.permissions?.users?.create);

  if (!canRead && !canCreate) {
    return null;
  }

  return (
    <Box
      sx={{
        backgroundColor: '#0a0a0a',
        minHeight: 'calc(100vh - 200px)',
        position: 'relative',
        px: { xs: 2, sm: 3 },
        pt: showPageTitle ? 2 : 1,
        pb: 10,
      }}
    >
      {showPageTitle && (canRead || canCreate) && (
        <Typography
          variant="h5"
          component="h1"
          sx={{ color: '#fafafa', fontWeight: 600, letterSpacing: '-0.02em', mb: 2 }}
        >
          {canRead ? 'Users' : 'Invite user'}
        </Typography>
      )}
      {outlet ?? <UsersList />}
    </Box>
  );
};
